<div class="edit-user-roles-dialog">
  <h2 mat-dialog-title class="dialog-title">Edit User Roles</h2>

  <mat-dialog-content class="dialog-content">
    <div class="user-info-section">
      <div class="user-info">
        <div class="info-row">
          <span class="label">User:</span>
          <span class="value">{{ data.user.firstName }} {{ data.user.lastName }} ({{ data.user.userId }})</span>
        </div>
        <div class="info-row">
          <span class="label">Email:</span>
          <span class="value">{{ data.user.emailAddress }}</span>
        </div>
        <div class="info-row">
          <span class="label">Profile:</span>
          <span class="value">{{ data.profileName }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading()" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading roles...</p>
    </div>

    <div *ngIf="!isLoading()" class="roles-section">
      <!--
        Group toggle buttons. Click any combination — selected groups
        get the highlighted/primary style. Saved together as a flat
        array of GROUP_* codes on the server.
      -->
      <div class="groups-section">
        <div class="section-header">
          <strong>Role Groups</strong>
          <span class="group-counter">{{ selectedGroups().size }} selected</span>
        </div>
        <p class="section-hint">
          Pick one or more groups. A user can hold multiple groups — their effective rights are the union.
        </p>

        <div class="group-toggle-grid">
          <button
            *ngFor="let g of groupOptions"
            type="button"
            mat-stroked-button
            class="group-toggle"
            [class.group-toggle--selected]="isGroupSelected(g.code)"
            [disabled]="data.isEditingSelf"
            [matTooltip]="g.description"
            matTooltipPosition="above"
            (click)="toggleGroup(g.code)"
          >
            <mat-icon class="group-toggle__check" *ngIf="isGroupSelected(g.code)">check_circle</mat-icon>
            <span class="group-toggle__label">{{ g.label }}</span>
          </button>
        </div>
      </div>

      <!--
        Individual rights — collapsible. Most assignments are pure
        group-based, so we keep the noisy per-role list out of sight by
        default. Expanding reveals search + multi-select + chips.
      -->
      <mat-expansion-panel class="individual-panel" [expanded]="individualSelectedCount > 0">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <strong>Individual Rights</strong>
          </mat-panel-title>
          <mat-panel-description>
            {{ individualSelectedCount }} of {{ individualTotalCount }} assigned
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="individual-roles-section">
          <div class="selection-info">
            <span class="selection-count">Selected: {{ individualSelectedCount }} of {{ individualTotalCount }} rights</span>
            <div class="selection-actions">
              <button mat-button (click)="selectAll()" type="button" [disabled]="data.isEditingSelf">Select All</button>
              <button mat-button (click)="deselectAll()" type="button">Deselect All</button>
            </div>
          </div>

          <div class="selected-roles-display" *ngIf="individualSelectedCount > 0">
            <div class="selected-roles-header">
              <strong>Currently Assigned Rights:</strong>
            </div>
            <mat-chip-set class="selected-chips">
              <mat-chip *ngFor="let role of rolesControl.value" [removable]="true" (removed)="removeRole(role)">
                {{ role }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-set>
          </div>

          <div class="no-roles-message" *ngIf="individualSelectedCount === 0">
            <p><em>No individual rights assigned (group memberships above cover most use cases).</em></p>
          </div>

          <div class="self-edit-warning" *ngIf="data.isEditingSelf">
            <p><strong>Note:</strong> You are editing your own roles. You can only remove roles, not add new ones.</p>
          </div>

          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search Available Rights</mat-label>
            <input matInput [formControl]="searchControl" placeholder="Type to filter rights..." />
          </mat-form-field>

          <mat-form-field appearance="outline" class="roles-select">
            <mat-label>Add / Remove Rights</mat-label>
            <mat-select [formControl]="rolesControl" multiple>
              <mat-option *ngFor="let role of filteredRoles()" [value]="role">
                {{ role }}
              </mat-option>
            </mat-select>
            <mat-hint>Click to add or remove individual rights</mat-hint>
          </mat-form-field>
        </div>
      </mat-expansion-panel>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <span class="total-count">Total assigned: {{ selectedTotal() }}</span>
    <button mat-button (click)="onCancel()" [disabled]="isSaving()" type="button">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="isLoading() || isSaving()" type="button">
      <span *ngIf="!isSaving()">Save</span>
      <span *ngIf="isSaving()">
        <mat-spinner
          diameter="20"
          style="display: inline-block; vertical-align: middle; margin-right: 8px"
        ></mat-spinner>
        Saving...
      </span>
    </button>
  </mat-dialog-actions>
</div>
